
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Product from "@/store/entities/baseInfo/Product";
import ProductCategory from "@/store/entities/baseInfo/ProductCategory";

@Component
export default class ProductList extends AbpBase {
  @Prop({ type: Object, default: null }) parentCategory: ProductCategory;
  @Prop({ type: Object, default: null }) currentCategory: ProductCategory;
  @Prop({ type: Boolean, default: false }) isSearchPage: boolean;
  @Prop({ type: Number, default: 0 }) searchResultCount: number;

  keyword: string = "";
  sorting: string = "";

  get colorList() {
    return this.$store.state.productColor.list;
  }

  created() {
    this.getColorList();
    this.changeKeyword();
    
    if (this.$route.query.sorting) {
      this.sorting = this.$route.query.sorting.toString();
    }
  }

  @Watch("$route")
  routeChange(to: any) {
    this.changeKeyword();
  }

  changeKeyword() {
    if (this.$route.query.q) {
      this.keyword = this.$route.query.q.toString();
    }
  }

  handleColorChange(colorId) {
    this.$emit("on-color-change", colorId);
  }

  async getColorList() {
    await this.$store.dispatch({
      type: "productColor/getList"
    });
  }

  orderBy(key) {
    let currentUrl = this.$route.query;
    let noneQuery = Object.keys(this.$route.query).length == 0;
    let fullPath = this.$route.fullPath;
    let queryChar = noneQuery ? "?" : "&";
    this.$route.query.sorting;

    if (!noneQuery) {
      this.$route.query["p"] = "1";
      let url = this.$route.path + "?sorting=" + key;
      Object.keys(this.$route.query).forEach(qi => {
        if (qi.toLowerCase() !== "sorting") {
          url += "&" + qi + "=" + this.$route.query[qi];
        }
      });
      location.href = url;
    } else {
      location.href = fullPath + queryChar + "sorting=" + key;
    }
  }
}
